export type RouteSettingsPreset = 'student' | 'car' | 'bike' | 'foot' | 'delivery' | 'pubcrawl' | 'roadtrip'

export interface RouteSettings {
  name: string;
  custom: boolean;
  breakTime: number;
  startTime: string;
  startDate: string;
  timeLimit: number;
  type: 'AB' | 'AA' | 'fastest';
  method: 'fastest' | 'custom';
  mapStyle?: string;
  vehicle: 'car' | 'truck' | 'bike' | 'foot';
  detailed: boolean;
  private: boolean;
}

export class RouteSettingsModel implements RouteSettings {
  name = 'Unavngivet rute'
  custom = false
  breakTime = 0
  startTime = '12:00'
  startDate = new Date().toISOString().split('T')[0]
  timeLimit = 0
  type: 'AB' | 'AA' | 'fastest' = 'AB'
  method: 'fastest' | 'custom' = 'fastest'
  mapStyle = 'streets-v10'
  vehicle: 'car' | 'truck' | 'bike' | 'foot' = 'car'
  detailed = false
  private = false

  constructor(preset?: RouteSettingsPreset) {

    if (preset == 'student') {
      this.name = 'Vogntur ' + (new Date().getMonth() > 7 ? new Date().getFullYear() + 1 : new Date().getFullYear()) + ' 🥳🍺🚒'
      this.custom = false
      this.breakTime = 15 * 60
      this.startTime = '12:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'truck'
      this.private = false
    }

    if (preset == 'car') {
      this.name = 'Køretur 🚗💨'
      this.custom = false
      this.breakTime = 0
      this.startTime = '00:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'car'
      this.private = false
    }

    if (preset == 'bike') {
      this.name = 'Cykeltur 🚴💨'
      this.custom = false
      this.breakTime = 0
      this.startTime = '00:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'bike'
      this.private = false
    }

    if (preset == 'foot') {
      this.name = 'Gåtur 🚶🏽‍♂️💨'
      this.custom = false
      this.breakTime = 0
      this.startTime = '00:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'foot'
      this.private = false
    }

    if (preset == 'delivery') {
      this.name = 'Leveringsrute'
      this.custom = false
      this.breakTime = 5 * 60
      this.startTime = '00:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'bike'
      this.private = false
    }

    if (preset == 'pubcrawl') {
      this.name = 'Pubcrawl'
      this.custom = false
      this.breakTime = 30 * 60
      this.startTime = '19:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'foot'
      this.private = false
    }

    if (preset == 'roadtrip') {
      this.name = 'Roadtrip'
      this.custom = false
      this.breakTime = 60 * 60
      this.startTime = '10:00'
      this.type = 'AB'
      this.method = 'fastest'
      this.vehicle = 'car'
      this.private = false
    }
  }
}  